import type { ScheduleTone } from "./scheduleLayout";

// Лентата по тона — същите цветове и контур като мострите в легендата
// (components/legendSwatches.ts): предстояща = „Резервирана" (пунктир),
// настанена = „Заета". Пунктирът е САМО за „Резервирана" (както на схемата) и
// е блед — погледът отива в името, не в рамката.
export const BAR_TONE: Record<ScheduleTone, string> = {
  upcoming: "border-2 border-dashed border-schema-reserved-edge-soft bg-schema-reserved text-schema-reserved-ink",
  seated: "border-[1.5px] border-schema-occupied-edge bg-schema-occupied text-schema-occupied-ink",
  expired: "border-[1.5px] border-reservation-expired-edge bg-fill text-reservation-expired-ink",
  // text-soft (не text-muted): 4.5:1 и в светлата тема — надписът е дребен.
  completed: "border-[1.5px] border-shade-4 bg-fill text-soft",
};
